import PhoneVerificationModal from 'components/GlobalModals/PhoneVerificationModal/PhoneVerificationModal';
import { withPhoneVerificationModalProps } from 'viewModel/globalModals/phoneVerificationModal/withPhoneVerificationModalProps';

export default withPhoneVerificationModalProps(PhoneVerificationModal);
